import React from 'react';
import { Link } from 'react-router-dom';
interface CTAButtonProps {
  text: string;
  to: string;
  className?: string;
}
const CTAButton: React.FC<CTAButtonProps> = ({
  text,
  to,
  className = ''
}) => {
  return <Link to={to} className={`btn-primary ${className}`} data-id="element-113">
      {text}
    </Link>;
};
export default CTAButton;